"use client";

import classNames from "classnames";
import Image from "next/image";
import { PorangeButton } from "../atoms/PorangeButton";
import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";
import { pushGtmEvent } from "@/utils/google-tag-manager";
import { GtmEvents, GtmProperties } from "@/constants/google-tag-manager";
import { VETTED_PLACES_WORLDWIDE } from "../../constants";

const inter = Inter({ subsets: ["latin"] });

export const Certificate = ({ color = "black", size = 36 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 36 37"
            fill="none">
            <path
                d="M18 19.6631C18 19.9615 17.8815 20.2476 17.6705 20.4586C17.4595 20.6696 17.1734 20.7881 16.875 20.7881H10.125C9.82663 20.7881 9.54048 20.6696 9.3295 20.4586C9.11853 20.2476 9 19.9615 9 19.6631C9 19.3647 9.11853 19.0786 9.3295 18.8676C9.54048 18.6566 9.82663 18.5381 10.125 18.5381H16.875C17.1734 18.5381 17.4595 18.6566 17.6705 18.8676C17.8815 19.0786 18 19.3647 18 19.6631ZM16.875 14.0381H10.125C9.82663 14.0381 9.54048 14.1566 9.3295 14.3676C9.11853 14.5786 9 14.8647 9 15.1631C9 15.4615 9.11853 15.7476 9.3295 15.9586C9.54048 16.1696 9.82663 16.2881 10.125 16.2881H16.875C17.1734 16.2881 17.4595 16.1696 17.6705 15.9586C17.8815 15.7476 18 15.4615 18 15.1631C18 14.8647 17.8815 14.5786 17.6705 14.3676C17.4595 14.1566 17.1734 14.0381 16.875 14.0381ZM32.625 23.2448V32.0381C32.6268 32.2364 32.5761 32.4317 32.4781 32.6041C32.3801 32.7766 32.2382 32.92 32.0669 33.02C31.8956 33.1199 31.7009 33.1728 31.5025 33.1732C31.3042 33.1736 31.1093 33.1216 30.9375 33.0225L27.5625 31.0903L24.1875 33.0225C24.0157 33.1216 23.8208 33.1736 23.6225 33.1732C23.4241 33.1728 23.2294 33.1199 23.0581 33.02C22.8868 32.92 22.7449 32.7766 22.6469 32.6041C22.5489 32.4317 22.4982 32.2364 22.5 32.0381V28.6631H5.625C5.02826 28.6631 4.45597 28.426 4.03401 28.0041C3.61205 27.5821 3.375 27.0098 3.375 26.4131V8.41309C3.375 7.81635 3.61205 7.24405 4.03401 6.8221C4.45597 6.40014 5.02826 6.16309 5.625 6.16309H30.375C30.9717 6.16309 31.544 6.40014 31.966 6.8221C32.3879 7.24405 32.625 7.81635 32.625 8.41309V12.7064C33.3362 13.3874 33.9021 14.2053 34.2887 15.1109C34.6754 16.0165 34.8747 16.9909 34.8747 17.9756C34.8747 18.9602 34.6754 19.9347 34.2887 20.8403C33.9021 21.7458 33.3362 22.5638 32.625 23.2448ZM22.5 26.4131V23.2448C21.274 22.0625 20.4993 20.4893 20.3093 18.7967C20.1194 17.1041 20.5263 15.3984 21.4597 13.9737C22.3931 12.5491 23.7945 11.495 25.4222 10.9932C27.0498 10.4915 28.8015 10.5737 30.375 11.2256V8.41309H5.625V26.4131H22.5ZM30.375 24.7256C29.4841 25.0978 28.5281 25.2895 27.5625 25.2895C26.5969 25.2895 25.6409 25.0978 24.75 24.7256V30.1003L27 28.8121C27.17 28.715 27.3624 28.6638 27.5583 28.6638C27.7541 28.6638 27.9465 28.715 28.1166 28.8121L30.3666 30.1003L30.375 24.7256ZM32.625 17.9756C32.625 16.9743 32.3281 15.9955 31.7718 15.163C31.2155 14.3305 30.4249 13.6816 29.4998 13.2984C28.5748 12.9153 27.5569 12.815 26.5749 13.0104C25.5928 13.2057 24.6908 13.6879 23.9828 14.3959C23.2748 15.1039 22.7926 16.0059 22.5973 16.9879C22.4019 17.97 22.5022 18.9879 22.8854 19.9129C23.2685 20.838 23.9174 21.6286 24.7499 22.1849C25.5824 22.7412 26.5612 23.0381 27.5625 23.0381C28.2273 23.0381 28.8856 22.9071 29.4998 22.6527C30.114 22.3983 30.6721 22.0254 31.1422 21.5553C31.6123 21.0852 31.9852 20.5271 32.2396 19.9129C32.4941 19.2987 32.625 18.6404 32.625 17.9756Z"
                fill={color}
            />
        </svg>
    );
};

export const Faders = ({ color = "black", size = 36 }) => {
    return (
        <svg
            width="48"
            height="49"
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25.5 22.5532V40.5532C25.5 40.951 25.342 41.3326 25.0607 41.6139C24.7794 41.8952 24.3978 42.0532 24 42.0532C23.6022 42.0532 23.2206 41.8952 22.9393 41.6139C22.658 41.3326 22.5 40.951 22.5 40.5532V22.5532C22.5 22.1554 22.658 21.7739 22.9393 21.4926C23.2206 21.2113 23.6022 21.0532 24 21.0532C24.3978 21.0532 24.7794 21.2113 25.0607 21.4926C25.342 21.7739 25.5 22.1554 25.5 22.5532ZM37.5 36.0532C37.1022 36.0532 36.7206 36.2113 36.4393 36.4926C36.158 36.7739 36 37.1554 36 37.5532V40.5532C36 40.951 36.158 41.3326 36.4393 41.6139C36.7206 41.8952 37.1022 42.0532 37.5 42.0532C37.8978 42.0532 38.2794 41.8952 38.5607 41.6139C38.842 41.3326 39 40.951 39 40.5532V37.5532C39 37.1554 38.842 36.7739 38.5607 36.4926C38.2794 36.2113 37.8978 36.0532 37.5 36.0532ZM42 30.0532H39V7.55322C39 7.1554 38.842 6.77387 38.5607 6.49256C38.2794 6.21126 37.8978 6.05322 37.5 6.05322C37.1022 6.05322 36.7206 6.21126 36.4393 6.49256C36.158 6.77387 36 7.1554 36 7.55322V30.0532H33C32.6022 30.0532 32.2206 30.2113 31.9393 30.4926C31.658 30.7739 31.5 31.1554 31.5 31.5532C31.5 31.951 31.658 32.3326 31.9393 32.6139C32.2206 32.8952 32.6022 33.0532 33 33.0532H42C42.3978 33.0532 42.7794 32.8952 43.0607 32.6139C43.342 32.3326 43.5 31.951 43.5 31.5532C43.5 31.1554 43.342 30.7739 43.0607 30.4926C42.7794 30.2113 42.3978 30.0532 42 30.0532ZM10.5 30.0532C10.1022 30.0532 9.72064 30.2113 9.43934 30.4926C9.15804 30.7739 9 31.1554 9 31.5532V40.5532C9 40.951 9.15804 41.3326 9.43934 41.6139C9.72064 41.8952 10.1022 42.0532 10.5 42.0532C10.8978 42.0532 11.2794 41.8952 11.5607 41.6139C11.842 41.3326 12 40.951 12 40.5532V31.5532C12 31.1554 11.842 30.7739 11.5607 30.4926C11.2794 30.2113 10.8978 30.0532 10.5 30.0532ZM15 24.0532H12V7.55322C12 7.1554 11.842 6.77387 11.5607 6.49256C11.2794 6.21126 10.8978 6.05322 10.5 6.05322C10.1022 6.05322 9.72064 6.21126 9.43934 6.49256C9.15804 6.77387 9 7.1554 9 7.55322V24.0532H6C5.60218 24.0532 5.22064 24.2113 4.93934 24.4926C4.65804 24.7739 4.5 25.1554 4.5 25.5532C4.5 25.951 4.65804 26.3326 4.93934 26.6139C5.22064 26.8952 5.60218 27.0532 6 27.0532H15C15.3978 27.0532 15.7794 26.8952 16.0607 26.6139C16.342 26.3326 16.5 25.951 16.5 25.5532C16.5 25.1554 16.342 24.7739 16.0607 24.4926C15.7794 24.2113 15.3978 24.0532 15 24.0532ZM28.5 15.0532H25.5V7.55322C25.5 7.1554 25.342 6.77387 25.0607 6.49256C24.7794 6.21126 24.3978 6.05322 24 6.05322C23.6022 6.05322 23.2206 6.21126 22.9393 6.49256C22.658 6.77387 22.5 7.1554 22.5 7.55322V15.0532H19.5C19.1022 15.0532 18.7206 15.2113 18.4393 15.4926C18.158 15.7739 18 16.1554 18 16.5532C18 16.951 18.158 17.3326 18.4393 17.6139C18.7206 17.8952 19.1022 18.0532 19.5 18.0532H28.5C28.8978 18.0532 29.2794 17.8952 29.5607 17.6139C29.842 17.3326 30 16.951 30 16.5532C30 16.1554 29.842 15.7739 29.5607 15.4926C29.2794 15.2113 28.8978 15.0532 28.5 15.0532Z"
                fill="#FFB95A"
            />
        </svg>
    );
};

export const CertificateIcon = ({ color = "black", size = 36 }) => {
    return (
        <svg
            width="48"
            height="49"
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24 25.5532C24 25.951 23.842 26.3326 23.5607 26.6139C23.2794 26.8952 22.8978 27.0532 22.5 27.0532H13.5C13.1022 27.0532 12.7206 26.8952 12.4393 26.6139C12.158 26.3326 12 25.951 12 25.5532C12 25.1554 12.158 24.7739 12.4393 24.4926C12.7206 24.2113 13.1022 24.0532 13.5 24.0532H22.5C22.8978 24.0532 23.2794 24.2113 23.5607 24.4926C23.842 24.7739 24 25.1554 24 25.5532ZM22.5 18.0532H13.5C13.1022 18.0532 12.7206 18.2113 12.4393 18.4926C12.158 18.7739 12 19.1554 12 19.5532C12 19.951 12.158 20.3326 12.4393 20.6139C12.7206 20.8952 13.1022 21.0532 13.5 21.0532H22.5C22.8978 21.0532 23.2794 20.8952 23.5607 20.6139C23.842 20.3326 24 19.951 24 19.5532C24 19.1554 23.842 18.7739 23.5607 18.4926C23.2794 18.2113 22.8978 18.0532 22.5 18.0532ZM43.5 30.3288V42.0532C43.5024 42.3177 43.4348 42.578 43.3041 42.808C43.1734 43.0379 42.9843 43.2291 42.7559 43.3624C42.5274 43.4956 42.2678 43.5661 42.0034 43.5667C41.7389 43.5673 41.479 43.498 41.25 43.3657L36.75 40.7895L32.25 43.3657C32.021 43.498 31.7611 43.5673 31.4966 43.5667C31.2322 43.5661 30.9726 43.4956 30.7441 43.3624C30.5157 43.2291 30.3266 43.0379 30.1959 42.808C30.0652 42.578 29.9976 42.3177 30 42.0532V37.5532H7.5C6.70435 37.5532 5.94129 37.2372 5.37868 36.6745C4.81607 36.1119 4.5 35.3489 4.5 34.5532V10.5532C4.5 9.75757 4.81607 8.99451 5.37868 8.4319C5.94129 7.86929 6.70435 7.55322 7.5 7.55322H40.5C41.2957 7.55322 42.0587 7.86929 42.6213 8.4319C43.1839 8.99451 43.5 9.75757 43.5 10.5532V16.2776C44.4482 17.1856 45.2028 18.2762 45.7183 19.4836C46.2338 20.6911 46.4996 21.9904 46.4996 23.3032C46.4996 24.6161 46.2338 25.9154 45.7183 27.1228C45.2028 28.3302 44.4482 29.4208 43.5 30.3288ZM30 34.5532V30.3288C28.3654 28.7524 27.3323 26.6548 27.0791 24.3981C26.8259 22.1413 27.3683 19.8669 28.6129 17.9674C29.8575 16.0679 31.7261 14.6624 33.8962 13.9934C36.0664 13.3245 38.402 13.4341 40.5 14.3032V10.5532H7.5V34.5532H30ZM40.5 32.3032C39.3121 32.7995 38.0374 33.0551 36.75 33.0551C35.4626 33.0551 34.1879 32.7995 33 32.3032V39.4695L36 37.752C36.2267 37.6224 36.4833 37.5542 36.7444 37.5542C37.0055 37.5542 37.2621 37.6224 37.4888 37.752L40.4888 39.4695L40.5 32.3032ZM43.5 23.3032C43.5 21.9682 43.1041 20.6632 42.3624 19.5531C41.6207 18.4431 40.5665 17.5779 39.3331 17.067C38.0997 16.5561 36.7425 16.4225 35.4331 16.6829C34.1238 16.9434 32.921 17.5862 31.977 18.5303C31.033 19.4743 30.3901 20.677 30.1297 21.9864C29.8692 23.2957 30.0029 24.6529 30.5138 25.8863C31.0247 27.1197 31.8899 28.1739 32.9999 28.9156C34.1099 29.6573 35.415 30.0532 36.75 30.0532C37.6364 30.0532 38.5142 29.8786 39.3331 29.5394C40.1521 29.2002 40.8962 28.703 41.523 28.0762C42.1498 27.4494 42.647 26.7053 42.9862 25.8863C43.3254 25.0674 43.5 24.1896 43.5 23.3032Z"
                fill="#18C1AE"
            />
        </svg>
    );
};

export const ChatCenteredText = ({ color = "black", size = 36 }) => {
    return (
        <svg
            width="48"
            height="49"
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.5 19.5532C16.5 19.1554 16.658 18.7739 16.9393 18.4926C17.2206 18.2113 17.6022 18.0532 18 18.0532H30C30.3978 18.0532 30.7794 18.2113 31.0607 18.4926C31.342 18.7739 31.5 19.1554 31.5 19.5532C31.5 19.951 31.342 20.3326 31.0607 20.6139C30.7794 20.8952 30.3978 21.0532 30 21.0532H18C17.6022 21.0532 17.2206 20.8952 16.9393 20.6139C16.658 20.3326 16.5 19.951 16.5 19.5532ZM18 27.0532H30C30.3978 27.0532 30.7794 26.8952 31.0607 26.6139C31.342 26.3326 31.5 25.951 31.5 25.5532C31.5 25.1554 31.342 24.7739 31.0607 24.4926C30.7794 24.2113 30.3978 24.0532 30 24.0532H18C17.6022 24.0532 17.2206 24.2113 16.9393 24.4926C16.658 24.7739 16.5 25.1554 16.5 25.5532C16.5 25.951 16.658 26.3326 16.9393 26.6139C17.2206 26.8952 17.6022 27.0532 18 27.0532ZM43.5 10.5532V34.5532C43.5 35.3489 43.1839 36.1119 42.6213 36.6745C42.0587 37.2372 41.2957 37.5532 40.5 37.5532H29.1694L26.6044 42.042C26.3419 42.501 25.9628 42.8825 25.5055 43.1478C25.0481 43.4132 24.5288 43.5529 24 43.5529C23.4712 43.5529 22.9519 43.4132 22.4945 43.1478C22.0372 42.8825 21.6581 42.501 21.3956 42.042L18.8306 37.5532H7.5C6.70435 37.5532 5.94129 37.2372 5.37868 36.6745C4.81607 36.1119 4.5 35.3489 4.5 34.5532V10.5532C4.5 9.75757 4.81607 8.99451 5.37868 8.4319C5.94129 7.86929 6.70435 7.55322 7.5 7.55322H40.5C41.2957 7.55322 42.0587 7.86929 42.6213 8.4319C43.1839 8.99451 43.5 9.75757 43.5 10.5532ZM40.5 10.5532H7.5V34.5532H19.7006C19.9662 34.5508 20.2277 34.619 20.4583 34.7508C20.6889 34.8826 20.8803 35.0732 21.0131 35.3032L24.0131 40.5532L27.0131 35.3032C27.1459 35.0732 27.3374 34.8826 27.568 34.7508C27.7986 34.619 28.06 34.5508 28.3256 34.5532H40.5V10.5532Z"
                fill="#FD5495"
            />
        </svg>
    );
};

export const BoxAlignment = {
    CENTER: "center",
    FLEX_START: "flex-start",
    START: "start",
    STRETCH: "stretch",
    ROW: "row",
    COL: "col",
};
export const Box = ({
    children,
    className,
    alignment = BoxAlignment.CENTER,
    // onClick = () => {},
    transparent = false,
}) => {
    return (
        <div
            // onClick={onClick}
            className={classNames(className, inter.className, {
                "rounded-2xl px-6 py-3 md:px-3": true,
                "bg-[#001C3D]": !transparent,
                "text-white": true,
                "flex flex-col w-full": alignment === BoxAlignment.STRETCH,
                "flex items-center justify-between flex-col md:flex-row":
                    alignment === BoxAlignment.ROW,
                "flex flex-col items-start md:items-center text-left md:text-center":
                    alignment === BoxAlignment.FLEX_START,
                "flex flex-col items-start justify-between":
                    alignment === BoxAlignment.START,
                "flex flex-col justify-center items-center":
                    alignment === BoxAlignment.CENTER,
            })}>
            {children}
        </div>
    );
};

const IMAGE_SIZE = 36;

const Testimony = ({ text, name, glutenFreeLevel, imageSrc }) => {
    return (
        <Box
            alignment={BoxAlignment.START}
            className="py-5 gap-5">
            <p
                className={classNames(
                    inter.className,
                    "text-[15px] leading-normal font-semibold text-left mb-3"
                )}>
                {text}
            </p>
            <div className="flex gap-2 items-center text-left">
                <Image
                    src={imageSrc}
                    alt={name}
                    width={IMAGE_SIZE}
                    height={IMAGE_SIZE}
                />
                <div className="flex flex-col justify-center text-xs">
                    <p className={classNames(inter.className, "font-bold")}>{name}</p>
                    <p className={classNames(inter.className)}>{glutenFreeLevel}</p>
                </div>
            </div>
        </Box>
    );
};

export const Feature = ({ title, subtitle, icon }) => {
    return (
        <Box alignment={BoxAlignment.FLEX_START}>
            <span className="mb-3">{icon}</span>
            <h3
                className={classNames(
                    inter.className,
                    "text-[15px] font-semibold leading-normal mb-1 md:mb-0"
                )}>
                {title}
            </h3>
            <p
                className={classNames(inter.className, {
                    "flex flex-col md:text-center leading-snug md:justify-center md:leading-tight": true,
                    "text-[13px]": true,
                })}>
                {subtitle}
            </p>
        </Box>
    );
};

export const GlutenFreeFooter = ({
    pageTitle,
    pageArea,
    isMobile,
    placesCount,
    link,
}) => {
    return (
        <div
            id="gfe-top-ten-footer"
            className={classNames(
                inter.className,
                "px-5 mt-5",
                "w-full bg-blue-900 pt-12 pb-32 text-center flex flex-col justify-center items-center"
            )}>
            <h1
                className={classNames(
                    inter.className,
                    "md:px-0 text-4xl font-bold font-mont-bold max-w-6xl text-white mb-1"
                )}>
                Explore{" "}
                {placesCount > 1 ? `${placesCount} GF spots` : "tons of GF spots"}{" "}
                {pageArea ? `in ${pageArea}` : "worldwide"}
            </h1>
            <h2 className="md:px-0 m-auto md:w-96 text-white text-xl font-normal leading-[30px] mb-5">
                and {VETTED_PLACES_WORLDWIDE} GF places worldwide!
            </h2>
            <div
                id="footer-get-the-app-button"
                data-page-name={pageTitle}
                data-device={isMobile ? "mobile" : "desktop"}
                className="mb-10">
                <PorangeButton>Start Free Trial</PorangeButton>
            </div>
            <div className="mb-3">
                <section className="w-full max-w-7xl flex flex-col items-center">
                    <div className="w-full flex flex-col md:text-center md:grid md:grid-cols-3 gap-3 mb-3">
                        <Feature
                            isMobile={isMobile}
                            title="Built with dieticians"
                            subtitle="Vetted information about every place’s celiac safety"
                            icon={<Certificate color="#18C1AE" />}
                        />
                        <Feature
                            isMobile={isMobile}
                            title="Advanced Filters"
                            subtitle="Quickly find the exact GF restaurant you are looking for"
                            icon={<Faders color="#FFB95A" />}
                        />
                        <Feature
                            isMobile={isMobile}
                            title="Celiac community"
                            subtitle="320K+ reviews and tips by like minded celiacs"
                            icon={<ChatCenteredText color="#FD5495" />}
                        />
                    </div>
                    <div className="w-full flex flex-col md:grid md:grid-cols-2 gap-3 md:mx-0 mb-3">
                        <Testimony
                            text="I have been using it now for 3 months and it saves me so much research. Reduces the need to call and double check every time."
                            name="Kenneth M."
                            glutenFreeLevel="Gluten Intolerant"
                            imageSrc="https://assets-global.website-files.com/5d53975001f72a80a5fdf1f2/65d7591068960698a85a6e3a_Ellipse%2090.png"
                        />
                        <Testimony
                            text="Finding places to eat used to be such a drag. Atly made it so much easier. Love it!"
                            name="Jane G."
                            glutenFreeLevel="Highly symptomatic celiac"
                            imageSrc="https://assets-global.website-files.com/5d53975001f72a80a5fdf1f2/65d77b386669606bb68b8322_Ellipse%2090%20(1).png"
                        />
                    </div>
                </section>
                <Box alignment={BoxAlignment.STRETCH}>
                    <h2 className="mb-4 font-inter font-semibold md:font-bold text-[15px] md:text-[18px]">
                        Discover {VETTED_PLACES_WORLDWIDE} vetted Gluten Free places around the world!
                    </h2>
                    <span
                        id="footer-join-community-button"
                        data-page-name={pageTitle}
                        data-device={isMobile ? "mobile" : "desktop"}>
                        <PorangeButton>Join the community</PorangeButton>
                    </span>
                </Box>
            </div>
            <div
                className={classNames(inter.className, {
                    "w-full rounded-2xl px-6 py-3 md:px-3": true,
                    // 'bg-[#001C3D]': !transparent,
                    "text-white": true,
                    "flex items-center justify-between flex-col md:flex-row": true,
                })}>
                <span
                    className={classNames(
                        inter.className,
                        "mb-2 md:mb-0 text-lg font-bold leading-[27px] md:leading-normal"
                    )}>
                    Gluten Free Eats by Atly
                </span>
                <div className="flex gap-2">
                    <Image
                        id="footer-app-store-button"
                        src="/assets/app-store.svg"
                        alt="App Store"
                        width={158}
                        height={50}
                        onClick={() => {
                            trackItemTapped(MixpanelValues.ItemTapped.APP_STORE);
                            pushGtmEvent(GtmEvents.CLICK_INSTALL, {
                                [GtmProperties.GfeTopTen.PAGE_NAME]: pageTitle,
                                [GtmProperties.GfeTopTen.POSITION]: "footer",
                                [GtmProperties.GfeTopTen.ELEMENT_TEXT]: "appstore",
                                [GtmProperties.GfeTopTen.DEVICE]: isMobile
                                    ? "mobile"
                                    : "desktop",
                            });

                            link && window.open(link, "_blank");
                        }}
                    />
                    <Image
                        id="footer-play-store-button"
                        src="/assets/play-store.svg"
                        alt="Play Store"
                        width={167}
                        height={50}
                        onClick={() => {
                            trackItemTapped(MixpanelValues.ItemTapped.PLAY_STORE);
                            pushGtmEvent(GtmEvents.CLICK_INSTALL, {
                                [GtmProperties.GfeTopTen.PAGE_NAME]: pageTitle,
                                [GtmProperties.GfeTopTen.POSITION]: "footer",
                                [GtmProperties.GfeTopTen.ELEMENT_TEXT]: "playstore",
                                [GtmProperties.GfeTopTen.DEVICE]: isMobile
                                    ? "mobile"
                                    : "desktop",
                            });

                            link && window.open(link, "_blank");
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
